export default "__VITE_ASSET__B3QpP4fX__"